var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useIconProps from '../utils/use-icon-props';
import useStrokeWidth from '../utils/use-stroke-width';
const GreenCheck = (_a) => {
    var { bgColor = '#BAFFE5' } = _a, props = __rest(_a, ["bgColor"]);
    const iconProps = useIconProps(props);
    const strokeWidth = useStrokeWidth(iconProps.width);
    return (_jsxs("svg", Object.assign({}, iconProps, { viewBox: "0 0 74 74", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("circle", { cx: "37", cy: "37", r: "37", fill: bgColor }), _jsx("path", { stroke: "currentColor", d: "M19 34.8824L31.5926 49L53 25", strokeWidth: strokeWidth * 2 })] })));
};
export default GreenCheck;
